module.exports = __webpack_public_path__ + "static/type-safe-handler-9859ae0d0ffd1f561558572080d39722.png";